<template>
  <div class="UserAuditLog">
    <div v-if="loading">
      <b-spinner class="align-middle" label="Loading..."></b-spinner>
    </div>
    <div>
      <b-row align-v="center" align-h="between" class="mb-3 p-4">
        <b-col sm="5" md="7" cols="12" lg="5" class="ml-auto">
          <b-form-group
            label="Por página"
            label-cols-sm="6"
            label-cols-md="3"
            label-cols-lg="4"
            label-align-sm="right"
            label-size="sm"
            label-for="perPageSelect"
            class="mb-0"
          >
            <b-form-select
              v-model="perPage"
              id="perPageSelect"
              size="md"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        show-empty
        small
        stacked="md"
        class="text-left"
        style="font-family: Montserrat; font-weight: lighter; font-size: 14px"
        id="my-table"
        :items="AuditLog"
        :fields="AuditLogFields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        :busy="isBusy"
      >
        <template v-slot:empty>
          <div class="mt-2 text-center">
            <h6>El usuario no tiene registros.</h6>
          </div>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-dark my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Cargando...</strong>
          </div>
        </template>

        <template v-slot:emptyfiltered>
          <div class="my-2 text-center">
            <h6>No se encontraron resultados</h6>
          </div>
        </template>

      </b-table>
      <b-col lg="5" class="mx-auto pt-2">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "UserAuditLog",
  data() {
    return {
      loading: true,
      AuditLog: [],
      AccountTransactions: [],
      AuditLogFields: [
        {
          key: "the_action.name",
          label: "Acción",
          sortable: true,
        },
        {
          key: "element",
          label: "Elemento",
          sortable: true,
          sortDirection: "desc",
        },
         {
          key: "description",
          label: "Descripción",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "created_at",
          label: "Fecha",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      isBusy: false,
      filterOn: [],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
    }),
  },
  mounted() {
    this.getUserLogs();
  },
  methods: {
    ...mapActions([
      "GetAuditLogsByUser"
    ]),
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getUserLogs() {
      this.loading = true;
      let form = {
        id: this.$route.params.user_id,
      };
      this.GetAuditLogsByUser(form).then((response) => {
        if (response.code == 200) {
          this.AuditLog = response.data;
          this.totalRows = response.data.length;
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style scoped></style>
